import React from 'react';
import Pannello from './Pannello';
import TabellaDoppia from './TabellaDoppia';
import { persone, totaliCibo, perNome } from './analisi';

/**
 * Cibo e intolleranze, una riga per squadra.
 *
 * Esiste solo sulle edizioni che il cibo ce l'hanno (<code>torneo.cibo</code>): dove non si
 * mangia, questi numeri non vogliono dire niente e il pannello non compare affatto.
 *
 * Le persone sono giocatori piu' accompagnatori, perche' a tavola si siedono anche loro: e' il
 * numero con cui si ordina, ed e' diverso da quello con cui si fanno le squadre.
 */

/** Uno zero si mostra spento: in una tabella di conteggi il rumore sono gli zeri. */
const Numero = ({ valore }) =>
  valore ? <>{valore}</> : <span className="zero">0</span>;

/*
 * Le intestazioni dei conteggi sono abbreviate perche' in una tabella auto la colonna e' larga
 * quanto la sua intestazione: "Vegetariani" sopra una colonna di numeri a una cifra si prendeva
 * lo spazio che serve alle intolleranze, che sono testo vero. La parola intera sta nel title, e
 * la riga dei totali in fondo le scrive tutte per esteso.
 */
const INTESTAZIONI = [
  { testo: 'Squadra' },
  { testo: 'Pers.', titolo: "Persone a tavola: giocatori piu' accompagnatori" },
  { testo: 'Gioc.', titolo: 'Giocatori in distinta' },
  { testo: 'Acc.', titolo: 'Accompagnatori' },
  { testo: 'Cel.', titolo: 'Celiaci' },
  { testo: 'Veg.', titolo: 'Vegetariani' },
  { testo: 'Vegan.', titolo: 'Vegani' },
  { testo: 'Intolleranze' }
];

const PannelloCibo = ({ squadre, aperto = false }) => {
  const totali = totaliCibo(squadre);
  const ordinate = perNome(squadre);

  return (
    <Pannello
      aperto={aperto}
      icona="fa-utensils"
      titolo="Cibo e intolleranze"
      sommario={`${totali.persone} a tavola - ${totali.celiaci} celiaci, ${totali.vegetariani} vegetariani, ${totali.vegani} vegani`}
    >
      {squadre.length === 0 ? (
        <p className="pannello-vuoto">Nessuna squadra iscritta.</p>
      ) : (
        <>
          <TabellaDoppia
            intestazioni={INTESTAZIONI}
            righe={ordinate}
            riga={(s) => (
              <tr key={s.id}>
                <td><span className="nome-squadra" title={s.nome}>{s.nome}</span></td>
                <td><strong>{persone(s)}</strong></td>
                <td><Numero valore={s.giocatori} /></td>
                <td><Numero valore={s.accompagnatori} /></td>
                <td><Numero valore={s.celiaci} /></td>
                <td><Numero valore={s.vegetariani} /></td>
                <td><Numero valore={s.vegani} /></td>
                <td className="testo-libero" title={s.intolleranze || ''}>
                  {s.intolleranze
                    ? <span className="testo-troncato">{s.intolleranze}</span>
                    : <span className="zero">-</span>}
                </td>
              </tr>
            )}
          />

          {/* La riga dei totali sta in fondo. Non e' dentro le tabelle perche' con le righe
              spezzate in due colonne non esiste un solo "in fondo": una riga di chiusura per
              colonna direbbe due volte lo stesso numero, come se fossero due subtotali. */}
          <div className="riga-totali">
            <span><strong>{totali.squadre}</strong> squadre</span>
            <span><strong>{totali.persone}</strong> persone a tavola</span>
            <span><strong>{totali.giocatori}</strong> giocatori</span>
            <span><strong>{totali.accompagnatori}</strong> accompagnatori</span>
            <span><strong>{totali.celiaci}</strong> celiaci</span>
            <span><strong>{totali.vegetariani}</strong> vegetariani</span>
            <span><strong>{totali.vegani}</strong> vegani</span>
            <span><strong>{totali.conIntolleranze}</strong> squadre con intolleranze dichiarate</span>
          </div>
        </>
      )}
    </Pannello>
  );
};

export default PannelloCibo;
